import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import baseURL from '../url';
import './Cart.css';
import whatsappIcon from '../../images/wpp.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faShoppingCart, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Link as Anchor } from "react-router-dom";
import moneda from '../moneda';
import Swal from 'sweetalert2';
import { ToastContainer, toast } from 'react-toastify';
import MiPedido from '../MiPedido/MiPedido'
import "./Cart.css"; // si tienes CSS extra para el modal o wrapper
import FloatingCart from "../FloatingCart/FloatingCart";
export default function Cart() {
    const [cartItems, setCartItems] = useState([]);
    const [productos, setProductos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalIsOpen2, setModalIsOpen2] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    const [noteText, setNoteText] = useState('');
    const [location, setLocation] = useState('');
    const [name, setName] = useState('');
    const [telefono, setTelefono] = useState('');
    const [direccion, setDireccion] = useState('');
    const [codigo, setCodigo] = useState('');
    const [tienda, setTienda] = useState([]);
    const [descuento, setDescuento] = useState(0);
    const [codigoValido, setCodigoValido] = useState(false);
    const [totalPrice, setTotalPrice] = useState(0);
    const [deliveryOption, setDeliveryOption] = useState('');
    const [metodos, setMetodos] = useState([]);
    const [paymentMethod, setPaymentMethod] = useState('');
    const [pagoRecibir, setPagoRecibir] = useState('');
    const [estado, setEstado] = useState(null);
const createdAt = new Date()
  .toLocaleString('sv-SE', { timeZone: 'America/Lima' })
  .replace('T', ' ');
;

    const [shippingZone, setShippingZone] = useState('');
    const [shippingCost, setShippingCost] = useState(0);
    useEffect(() => {
        cargarTienda()
    }, []);
    useEffect(() => {
        // Calcular el precio total al cargar el carrito o al actualizar los productos
        let totalPriceCalc = 0;
        cartItems.forEach(item => {
            totalPriceCalc += item.precio * item.cantidad;
        });
        setTotalPrice(totalPriceCalc);
    }, [cartItems]);

    useEffect(() => {
        const fetchEstado = async () => {
            try {
                const response = await fetch(`${baseURL}/estado.php?`);
                const data = await response.json();
                if (data.error) {
                    console.error(data.error);
                } else {
                    setEstado(data.estado);
                }
            } catch (error) {
                console.error("Error al obtener el estado:", error);
            }
        };

        fetchEstado();
    }, []);
    const cargarTienda = () => {
        fetch(`${baseURL}/tiendaGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setTienda(data.tienda.reverse() || []);
            })
            .catch(error => console.error('Error al cargar datos:', error));
    };

    useEffect(() => {
        cargarMetodos();
        cargarProductos();
    }, [isFocused]);

    useEffect(() => {
        if (shippingZone === "Nasca" || shippingZone === "San Carlos" || shippingZone === "Santa Fé") {
            setShippingCost(2);
        }
        else if (shippingZone === "Cajuca" || shippingZone === "Buena Fé" || shippingZone === "Vista Alegre") {
            setShippingCost(3);
        }
        else {
            setShippingCost(0);
        }
    }, [shippingZone]);

    useEffect(() => {
        if (deliveryOption === 'pickup') {
            setShippingCost(0);
            setShippingZone('');
            setDireccion('');
        }
    }, [deliveryOption]);

    useEffect(() => {
        const fetchCartItems = async () => {
            const cart = JSON.parse(localStorage.getItem('cart')) || [];
            const promises = cart.map(async (cartItem) => {
                const producto = productos.find(producto => producto.idProducto === cartItem.idProducto);
                return {
                    ...producto,
                    cantidad: cartItem.cantidad,
                    items: cartItem.items,
                };
            });

            Promise.all(promises)
                .then((items) => {
                    setCartItems(items);
                    setLoading(false);
                })
                .catch((error) => {
                    console.error('Error al obtener detalles del carrito:', error);
                    setLoading(false);
                });
        };

        fetchCartItems();
    }, [productos, isFocused]);



    const cargarMetodos = () => {
        fetch(`${baseURL}/metodoGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                // Filtra solo los métodos con estado "Activo"
                const metodosActivos = (data.metodos || [])?.filter(metodo => metodo.estado === 'Activo');
                setMetodos(metodosActivos);
                console.log(metodosActivos);
            })
            .catch(error => console.error('Error al cargar datos bancarios:', error));
    };

    const cargarProductos = () => {
        fetch(`${baseURL}/productosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setProductos(data.productos || []);
            })
            .catch(error => console.error('Error al cargar productos:', error));
    };

    const obtenerImagen = (item) => {
        return item.imagen1 || item.imagen2 || item.imagen3 || item.imagen4 || null;
    };

    const openModal = () => {
        // 🔥 Bloquea scroll del body en móviles
        document.body.style.overflow = "hidden";
        document.body.style.position = "fixed";
        document.body.style.width = "100%";
        document.body.style.top = `-${window.scrollY}px`; // guarda el scroll actual

        setModalIsOpen(true);
        setIsFocused(true);
    };

    const closeModal = () => {
        // 🔥 Restaura el scroll original del body
        const scrollY = document.body.style.top;
        document.body.style.overflow = "";
        document.body.style.position = "";
        document.body.style.width = "";
        document.body.style.top = "";

        // Vuelve al lugar exacto donde estaba el usuario
        window.scrollTo(0, parseInt(scrollY || "0") * -1);

        setModalIsOpen(false);
        setIsFocused(false);
    };

    const openModal2 = () => {
        setModalIsOpen2(true);
    };

    const closeModal2 = () => {
        setModalIsOpen2(false);
    };

    const removeFromCart = (id) => {
        const updatedCart = cartItems.filter(item => item.idProducto !== id);
        setCartItems(updatedCart);
        localStorage.setItem('cart', JSON.stringify(updatedCart));
    };

    const clearCart = () => {
        setCartItems([]);
        localStorage.removeItem('cart');
    };

    const [codigos, setCodigos] = useState([]);

    useEffect(() => {
        cargarCodigos();

    }, []);

    const cargarCodigos = () => {
        fetch(`${baseURL}/codigosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setCodigos(data.codigos || []);
            })
            .catch(error => console.error('Error al cargar códigos:', error));
    };
    const handleWhatsappMessage = (data) => {
        const { idPedido, nombre, telefono, entrega, pago, codigo, total, nota, productos, pagoRecibir } = data;

        const formattedTotalPrice = total?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        const phoneNumber = `${tienda[0]?.telefono}`;

        // Formatear los detalles de los productos
        const productosDetails = productos.map(item => {
            return `\n✅ *${item.titulo}* \n      Precio: ${moneda} ${item?.precio?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}  x  ${item.cantidad}\n      ${item.items}\n`;
        }).join('');

        const message =
            `📬 *Nuevo Pedido*\n\n` +
            `👤 *Nombre:* ${nombre}\n` +
            `📞 *Teléfono:* ${telefono}\n` +
            `🚚 *Método de Entrega:* ${deliveryOption === 'delivery' ? 'A Domicilio' : 'Recojo en tienda'}\n` +
            `${deliveryOption === 'delivery' ? `🏙️ *Distrito:* ${shippingZone}\n` : ''}` +
            `${deliveryOption === 'delivery' ? `📍 *Dirección:* ${direccion}\n` : ''}\n` +
            `🛒 *Productos:*\n${productosDetails}\n` +
            `💵 *Sub total:* ${moneda} ${totalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}\n` +
            `🚚 *Costo de envío:* ${moneda} ${shippingCost}\n` +
            `💲 *Total:* ${moneda} ${(totalPrice + shippingCost).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}\n\n` +
            `💳 *Forma de Pago:* ${pago}\n\n` +
            `👆 Envíanos este mensaje ahora para procesar tu pedido.`;


        // URL de WhatsApp
        const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

        // --- Safari Fix ---
        const newWindow = window.open(whatsappUrl, "_blank");

        // Si Safari bloquea la pestaña → abrir en la misma pestaña
        if (!newWindow) {
            window.location.href = whatsappUrl;
        }

        // Limpiar estados (opcional, dependiendo de tu lógica)
        setName('');
        setLocation('');
        setNoteText('');
        setCodigo('');
        setModalIsOpen(false);
        setModalIsOpen2(false);
    };





    // Función para aumentar la cantidad de un producto en el carrito
    const increaseQuantity = (index) => {
        const updatedCartItems = [...cartItems];
        updatedCartItems[index].cantidad += 1;
        setCartItems(updatedCartItems);
        localStorage.setItem('cart', JSON.stringify(updatedCartItems));
    };

    // Función para disminuir la cantidad de un producto en el carrito
    const decreaseQuantity = (index) => {
        const updatedCartItems = [...cartItems];
        if (updatedCartItems[index].cantidad > 1) {
            updatedCartItems[index].cantidad -= 1;
            setCartItems(updatedCartItems);
            localStorage.setItem('cart', JSON.stringify(updatedCartItems));
        }
    };


    // pedido-------------------------------------------------------------------
    const [mensaje, setMensaje] = useState('');
    const crearPedido = async () => {
        // Validaciones antes de enviar
        if (!name.trim()) {
            Swal.fire('Atención', 'El nombre es obligatorio.', 'warning');
            return;
        }


        if (!telefono.trim()) {
            Swal.fire('Atención', 'El teléfono es obligatorio.', 'warning');
            return;
        }

        if (!/^\d{6,15}$/.test(telefono.trim())) {
            Swal.fire('Atención', 'Ingrese un número de teléfono válido.', 'warning');
            return;
        }

        if (deliveryOption === 'delivery') {
            if (!shippingZone) {
                Swal.fire('Atención', 'Debe seleccionar la zona de envío.', 'warning');
                return;
            }

            if (!direccion.trim()) {
                Swal.fire('Atención', 'Debe ingresar la dirección completa.', 'warning');
                return;
            }
        }

        // Validación de stock
        const excedidos = cartItems.filter(item => item.cantidad > item.stock);
        if (excedidos.length > 0) {
            const mensajeStock = excedidos.map(i => `${i.titulo} (Stock disponible: ${i.stock})`).join('\n');
            Swal.fire('Atención', `No hay suficiente stock para los siguientes productos:\n${mensajeStock}`, 'error');
            return;
        }

        setMensaje('Procesando...');

        try {
            // Construir la lista de productos del pedido
            const productosPedido = cartItems?.map(item => {
                return {
                    idProducto: item?.idProducto,
                    idCategoria: item.idCategoria,
                    titulo: item?.titulo,
                    cantidad: item?.cantidad,
                    items: item?.items,
                    precio: item?.precio,
                    imagen: obtenerImagen(item)
                };
            });

            // Convertir la lista de productos a JSON
            const productosPedidoJSON = JSON.stringify(productosPedido);

            // Calcular el precio total del pedido
            let totalPrice = 0;
            cartItems.forEach(item => {
                totalPrice += item?.precio * item?.cantidad;
            });

            // Enviar el pedido con el precio total descontado
            const formData = new FormData();
            formData.append('productos', productosPedidoJSON);
            formData.append('total', totalPrice + shippingCost);
            formData.append('nombre', name);
            formData.append('telefono', telefono || '');
            const entrega =
                deliveryOption === 'delivery' && shippingZone
                    ? `Envío a domicilio: ${shippingZone} (+${shippingCost}) - Dirección: ${direccion}`
                    : deliveryOption === 'pickup'
                        ? 'Recojo en tienda'
                        : '';

            formData.append('entrega', entrega);
            formData.append('pago', paymentMethod);
            formData.append('nota', noteText);
            formData.append('codigo', codigo);
            formData.append('estado', 'Pendiente');
            formData.append('pagado', 'No');
            formData.append('pagoRecibir', pagoRecibir);
            formData.append('createdAt', createdAt);

            const response = await fetch(`${baseURL}/pedidoPost.php`, {
                method: 'POST',
                body: formData,
            });

            const data = await response.json();
            if (data.idPedido) {
                setMensaje('');


                // Aquí pasamos los datos necesarios a handleWhatsappMessage
                handleWhatsappMessage(data);
                // Guardar el idPedido en localStorage
                localStorage.setItem('idPedido', data.idPedido);
                // Limpiar campos y cerrar modal
                setName('');
                setCodigo('');
                setNoteText('');
                closeModal();
                closeModal2();
                clearCart();
            } else if (data?.error) {
                setMensaje('');
                Swal.fire(
                    'Error',
                    data?.error,
                    'error'
                );
            }
        } catch (error) {
            console.error('Error:', error);
            setMensaje('');
            Swal.fire(
                'Error',
                'Error de conexión. Por favor, inténtelo de nuevo.',
                'error'
            );
        }
    };

    useEffect(() => {
        if (metodos && metodos.length > 0) {
            setPaymentMethod(metodos[0].tipo);
        }
    }, [metodos]);

    const handlePaymentChange = (metodo) => {
        setPaymentMethod(metodo);
        if (metodo === 'Transferencia') {
            setPagoRecibir('Si'); // Valor predeterminado "Sí" para Transferencia
        } else {
            setPagoRecibir(''); // Borra el valor si no es Transferencia
        }
    };
    const handlePagoRecibirChange = (value) => {
        setPagoRecibir(value);
    };
    return (
        <div>
            <ToastContainer />
            <div className="cart-wrapper">
                {/* MOSTRAR BOTÓN SOLO SI HAY PRODUCTOS Y EL MODAL NO ESTÁ ABIERTO */}
                {cartItems.length > 0 && !modalIsOpen && (
                    <FloatingCart
                        cartItems={cartItems}
                        totalPrice={totalPrice}
                        moneda={moneda}
                        openModal={openModal} // tu función actual
                    />
                )}
            </div>



            <Modal
                isOpen={modalIsOpen}
                className="modal-cart"
                overlayClassName="overlay-cart"
                onRequestClose={closeModal}
            >
                <div className='deFLex'>
                    <button onClick={closeModal} className="backButton">
                        <FontAwesomeIcon icon={faArrowLeft} />
                    </button>
                    <MiPedido />
                </div>

                {estado === 'Abierto' ? (
                    <>
                        {cartItems?.length === 0 ? (
                            <p className='nohay'>No hay productos</p>
                        ) : (
                            <>
                                <div className="modal-content-cart">
                                    {loading ? (
                                        <p>Cargando...</p>
                                    ) : (
                                        cartItems.map((item, index) => (
                                            <div key={item?.idProducto} className='cardProductCart'>
                                                <Anchor to={`/producto/${item?.idProducto}/${item?.titulo?.replace(/\s+/g, '-')}`} onClick={closeModal}>
                                                    <img src={obtenerImagen(item)} alt="imagen" />
                                                </Anchor>
                                                <div className='cardProductCartText'>
                                                    <h3>{item.titulo}</h3>
                                                    <span>
                                                        {item?.items?.map((sabor, i) => <span key={i}>{sabor}, </span>)}
                                                    </span>
                                                    <strong>{moneda} {item?.precio?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</strong>
                                                </div>
                                                <div className='deColumn'>
                                                    <button onClick={() => removeFromCart(item.idProducto)} className='deleteCart'>
                                                        <FontAwesomeIcon icon={faTrash} />
                                                    </button>
                                                    <div className='deFlexCantidad'>
                                                        <button onClick={() => decreaseQuantity(index)}>-</button>
                                                        <span>{item.cantidad}</span>
                                                        <button onClick={() => increaseQuantity(index)}>+</button>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    )}
                                </div>

                                {/* FORMULARIO DIRECTO DENTRO DEL MODAL */}
                                <div className='modal-send-form'>
                                    <h4>(*) Campos obligatorios</h4>

                                    <input
                                        type="text"
                                        id="name"
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                        placeholder='Apellido y Nombre (*)'
                                    />

                                    <input
                                        type="tel"
                                        id="telefono"
                                        value={telefono}
                                        onChange={(e) => setTelefono(e.target.value)}
                                        placeholder="Número de teléfono (*)"
                                        required
                                    />

                                    <div className='deFLexRadio'>
                                        <label>Opciones de entrega (*)</label>
                                        <div onClick={() => setDeliveryOption('delivery')}>
                                            <input
                                                type="radio"
                                                id="delivery"
                                                name="deliveryOption"
                                                value="delivery"
                                                checked={deliveryOption === 'delivery'}
                                                onChange={() => setDeliveryOption('delivery')}
                                            />
                                            <label htmlFor="delivery">Envío a domicilio</label>
                                        </div>
                                        <div onClick={() => setDeliveryOption('pickup')}>
                                            <input
                                                type="radio"
                                                id="pickup"
                                                name="deliveryOption"
                                                value="pickup"
                                                checked={deliveryOption === 'pickup'}
                                                onChange={() => setDeliveryOption('pickup')}
                                            />
                                            <label htmlFor="pickup">Recojo en tienda</label>
                                        </div>
                                    </div>

                                    {deliveryOption === 'delivery' && (
                                        <>
                                            <select
                                                value={shippingZone}
                                                onChange={(e) => setShippingZone(e.target.value)}
                                                className="selectEnvio"
                                            >
                                                <option value="">Seleccione zona de envío</option>
                                                <option value="Nasca">Nasca (+ s/2)</option>
                                                <option value="San Carlos">San Carlos (+ s/2)</option>
                                                <option value="Santa Fé">Santa Fé (+ s/2)</option>
                                                <option value="Cajuca">Cajuca (+ s/3)</option>
                                                <option value="Buena Fé">Buena Fé (+ s/3)</option>
                                                <option value="Vista Alegre">Vista Alegre (+ s/3)</option>
                                            </select>

                                            <input
                                                type="text"
                                                id="direccion"
                                                name="direccion"
                                                value={direccion}
                                                onChange={(e) => setDireccion(e.target.value)}
                                                placeholder="Dirección / Nro. (*)"
                                                className="inputDireccion"
                                            />
                                        </>
                                    )}

                                    <input
                                        type="hidden"
                                        name="entrega"
                                        value={
                                            deliveryOption === 'delivery'
                                                ? shippingZone
                                                : deliveryOption === 'pickup'
                                                    ? 'Recojo en tienda'
                                                    : ''
                                        }
                                    />

                                    {false && (
                                        <>
                                            <div className='deFLexRadio'>
                                                <label>Formas de pago (*)</label>
                                                {metodos?.map(metodo => (
                                                    <section key={metodo.idMetodo} className='columnRadio'>
                                                        <div>
                                                            <input
                                                                type="radio"
                                                                name="paymentMethod"
                                                                id={metodo.tipo}
                                                                value={metodo.tipo}
                                                                checked={paymentMethod === metodo.tipo}
                                                                onChange={() => handlePaymentChange(metodo.tipo)}
                                                            />
                                                            <label htmlFor={metodo.tipo}>{metodo.tipo}</label>
                                                        </div>

                                                        {paymentMethod === 'Transferencia' && metodo.tipo === 'Transferencia' && (
                                                            <section className='radioRecibi'>
                                                                <label htmlFor="">Pago al recibirlo</label>
                                                                <div>
                                                                    <input
                                                                        type="radio"
                                                                        name="pagoRecibir"
                                                                        id="Sí"
                                                                        value="Si"
                                                                        checked={pagoRecibir === 'Si'}
                                                                        onChange={() => handlePagoRecibirChange('Si')}
                                                                    />
                                                                    <label htmlFor="Sí">Sí</label>
                                                                </div>
                                                                <div>
                                                                    <input
                                                                        type="radio"
                                                                        name="pagoRecibir"
                                                                        id="No"
                                                                        value="No"
                                                                        checked={pagoRecibir === 'No'}
                                                                        onChange={() => handlePagoRecibirChange('No')}
                                                                    />
                                                                    <label htmlFor="No">No (envío comprobante)</label>
                                                                </div>
                                                            </section>
                                                        )}
                                                    </section>
                                                ))}
                                            </div>

                                            {metodos?.length > 0 && metodos.some(m => m.tipo === paymentMethod) && (
                                                metodos
                                                    .filter(metodo => metodo.tipo === paymentMethod)
                                                    .map(datos => (
                                                        datos?.datos && (
                                                            <div className='deFLexRadioMetod' key={datos.idDatos}>
                                                                <span>{datos.datos}</span>
                                                            </div>
                                                        )
                                                    ))
                                            )}
                                        </>
                                    )}

                                    <div className='deColumnCart'>
                                        <h4>Total:
                                            {moneda} {(totalPrice + shippingCost)
                                                .toString()
                                                .replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                        </h4>

                                        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '1rem' }}>
                                            {mensaje ? (
                                                <button type='button' className='btn' disabled>{mensaje}</button>
                                            ) : (
                                                <div className="btn-container">
                                                    <button type='button' onClick={crearPedido} className='btn'>
                                                        Finalizar pedido por WhatsApp
                                                    </button>
                                                    <br />
                                                    <br />
                                                    <br />
                                                    <br />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </>
                ) : (
                    <p className='nohay'>
                        El establecimiento se encuentra <br />
                        cerrado en estos momentos. <br />
                        Consulte por horarios de atención.
                    </p>
                )}
            </Modal>
        </div >
    );
}
